// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xlargeOnConfiend-badge-bafe2581"};